var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bottom-nav"
  }, [_c('div', {
    staticClass: "bottom-nav__item",
    on: {
      "click": function click($event) {
        return _vm.toggleTab(_vm.Tabs.HOME);
      }
    }
  }, [_c('div', {
    staticClass: "bottom-nav__icon",
    class: {
      'is-active': _vm.activeTab === _vm.Tabs.HOME
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z",
      "stroke": "white",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M9 22V12H15V22",
      "stroke": "white",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('div', {
    staticClass: "bottom-nav__name"
  }, [_vm._v("活動首頁")])]), _c('div', {
    staticClass: "bottom-nav__item",
    on: {
      "click": function click($event) {
        return _vm.toggleTab(_vm.Tabs.AWARDS);
      }
    }
  }, [_c('div', {
    staticClass: "bottom-nav__icon",
    class: {
      'is-active': _vm.activeTab === _vm.Tabs.AWARDS
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 12V22H4V12",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M22 7H2V12H22V7Z",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 22V7",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('div', {
    staticClass: "bottom-nav__name"
  }, [_vm._v("獎品清單")])]), _c('div', {
    staticClass: "bottom-nav__item",
    on: {
      "click": function click($event) {
        return _vm.toggleTab(_vm.Tabs.INTRO);
      }
    }
  }, [_c('div', {
    staticClass: "bottom-nav__icon",
    class: {
      'is-active': _vm.activeTab === _vm.Tabs.INTRO
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M14 2V8H20",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 13H8",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 17H8",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M10 9H9H8",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('div', {
    staticClass: "bottom-nav__name"
  }, [_vm._v("活動說明")])]), _c('div', {
    staticClass: "bottom-nav__item",
    on: {
      "click": function click($event) {
        return _vm.toggleTab(_vm.Tabs.INVITE_RECORDS);
      }
    }
  }, [_c('div', {
    staticClass: "bottom-nav__icon",
    class: {
      'is-active': _vm.activeTab === _vm.Tabs.INVITE_RECORDS
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M17 11L19 13L23 9",
      "stroke": "#2C2C2E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('div', {
    staticClass: "bottom-nav__name"
  }, [_vm._v("邀請紀錄")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }